<template>
    <div class="invite-through-search">
        <div id="preloader" v-if="load" class="preloader"></div>
        <base-modal
            mk="invite-through-search"
            :show.sync="show"
            :scroll="false"
            :styles="modalStyles"
        >
            <section class="step-header">
                <button class="modal-back-btn hidden">
                    <img src="/images/left-arrow-yellow.svg" alt="back-icon" />
                </button>
                <p class="title">{{ currentStep.title }}</p>
                <button @click="() => toggleModal(false)" class="modal-close-btn">
                    <img src="/images/close-event-modal-yellow.svg" alt="close-icon" />
                </button>
            </section>
            <section class="step-component">
                <component
                    :is="currentStep.component"
                    :artists="artists"
                    :event-id="parseInt(eventId)"
                    :clear-selection="clearSelection"
                    :user-data.sync="userData"
                    :validation.sync="validation"
                    :toggle-artist="toggleArtist"
                    @start-search="launchSearch"
                    @autocomplete-loaded="loadAutocomplete"
                ></component>
            </section>
            <section class="step-footer">
                <button
                    v-if="currentStep.identifier === 'results'"
                    @click="() => updateStep('search')"
                    class="filter-btn"
                >
                    <img
                        src="/images/icons/filter.svg"
                        class="filter-icon"
                        alt="filter-icon"
                    />
                    <span class="text">Filters</span>
                    <span v-if="filterCount" class="count">{{ filterCount }}</span>
                </button>
                <button
                    v-if="actionBtns.text[0]"
                    @click="() => clearData(currentStep.actions.clear)"
                    class="step-clear-btn"
                >
                    {{ actionBtns.text[0] }}
                </button>
                <button
                    :disabled="validation && validation.$invalid"
                    @click="() => actionBtns.action()"
                    class="step-continue-btn"
                >
                    {{ actionBtns.text[1] }}
                </button>
            </section>
        </base-modal>
    </div>
</template>
<script>
    import BaseModal from '@/composables/ui/useModal.js'
    import useCheckScreen from '@/composables/useCheckScreen.js'
    import { useInviteThroughSearch } from '@/composables/features/invite-through-search/useInviteThroughSearch'

    export default {
        name: 'InviteThroughSearch',
        components: {
            BaseModal
        },
        props: {
            eventId: {
                type: Number,
                required: true
            },
            bookerId: {
                type: Number,
                required: true
            },
            showModal: {
                type: Boolean,
                required: true
            }
        },
        emits: ['update:show-modal'],
        setup(props, context) {
            const {
                load,
                autocomplete,
                artists,
                clearSelection,
                userData,
                currentStep,
                actionBtns,
                show,
                toggleModal,
                clearData,
                validation,
                updateStep,
                searchArtists,
                filterCount,
                toggleArtist
            } = useInviteThroughSearch(props, context)
            const { isMobile, isTablet } = useCheckScreen()

            return {
                isMobile,
                isTablet,

                load,
                userData,
                clearSelection,
                artists,
                autocomplete,
                currentStep,
                actionBtns,
                show,
                validation,
                updateStep,
                toggleModal,
                clearData,
                searchArtists,
                filterCount,
                toggleArtist
            }
        },
        data: () => ({
            desktopStyles: {
                modalWrapper: {
                    position: 'fixed',
                    top: '124px',
                    left: '35%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '0px',
                    padding: '48px 40px 32px 40px',
                    background: '#262626',
                    borderRadius: '16px',
                    border: '1px solid #333',
                    width: '100%',
                    maxWidth: '882px',
                    maxHeight: '460px'
                }
            },
            mobileStyles: {
                modalWrapper: {
                    position: 'fixed',
                    top: '0px',
                    left: '0px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '0px',
                    padding: '28px 16px 40px 16px',
                    borderRadius: '15px',
                    width: '100%',
                    maxWidth: '760px',
                    height: '100vh',
                    background: '#121212'
                }
            },
            tabletStyles: {
                modalWrapper: {
                    position: 'fixed',
                    top: '124px',
                    left: '40px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '0px',
                    padding: '48px 40px 32px 40px',
                    background: '#262626',
                    borderRadius: '16px',
                    border: '1px solid #333',
                    width: '100%',
                    maxWidth: '500px',
                    maxHeight: '600px',
                    height: '72vh'
                }
            }
        }),
        computed: {
            modalStyles() {
                if (this.isTablet && !this.isMobile) {
                    return this.tabletStyles
                } else if (this.isMobile) {
                    return this.mobileStyles
                } else {
                    return this.desktopStyles
                }
            }
        },
        methods: {
            loadAutocomplete(autocomplete) {
                this.autocomplete = autocomplete
            },
            launchSearch() {
                this.searchArtists()
                this.updateStep('results')
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .invite-through-search {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        position: relative;

        .hidden {
            visibility: hidden;
        }
        .step-header {
            z-index: 9;
            background: inherit;
            width: 100%;
            position: absolute;
            top: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #333;

            .modal-back-btn,
            .modal-close-btn {
                width: 48px;
                height: 48px;
                padding: 12px;
                background: none;

                img {
                    width: 12px;
                    height: 12px;
                    object-fit: cover;
                }
            }
            .title {
                color: #dedede;
                text-align: center;
                font-family: 'Instrument Sans';
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 125%;
            }
        }
        .step-component {
            width: 100%;
            overflow-y: auto;
            padding-top: 16px;
            padding-bottom: 32px;
            -ms-overflow-style: none;
            scrollbar-width: none;

            @media screen and (max-width: 768px) {
                padding-top: 32px;
                height: auto;
                padding-bottom: 100px;
            }
        }
        .step-component::-webkit-scrollbar {
            display: none;
        }
        .step-footer {
            z-index: 9;
            background: inherit;
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            gap: 16px;
            padding-top: 24px;
            width: 100%;
            border-top: 1px solid #333;

            @media screen and (max-width: 768px) {
                padding-bottom: 40px;
            }

            .step-clear-btn,
            .step-continue-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 120px;
                padding: 10px 24px;
                font-family: 'Instrument Sans';
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 125%;
                text-transform: capitalize;
            }

            .step-clear-btn {
                background: transparent;
                border: 1px solid #cdeb09;
                color: #cdeb09;
            }
            .step-continue-btn {
                background: #cdeb09;
                color: black;
            }
            .step-continue-btn:disabled {
                opacity: 0.4;
            }
            .step-continue-btn:hover {
                background: #dedede;
            }

            .filter-btn {
                position: absolute;
                left: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 120px;
                padding: 8px 12px;
                background: transparent;
                border: none;
                gap: 4px;

                @media screen and (max-width: 768px) {
                    left: 16px;
                }

                .filter-icon {
                    height: 16px;
                    width: 16px;
                    object-fit: cover;
                }
                .text {
                    color: #8b8b8b;
                    font-family: 'Instrument Sans';
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 115%;
                    letter-spacing: 0.14px;
                }
                .count {
                    border-radius: 120px;
                    border: 1px solid rgba(0, 0, 0, 0);
                    background: #cdeb09;
                    padding: 0px 4px;
                    color: #000;
                    font-family: 'Instrument Sans';
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
            }
        }
    }
</style>
